import { FieldBase } from '@/domain/mitarbeiter/shared/components/form/fieldComponents/FieldBase';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { useZuschlagsgruppen } from '@/domain/mitarbeiter/features/anlageassistent/hooks/useZuschlagsgruppen/useZuschlagsgruppen';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import {
  Select,
  SelectClearItem,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

export function ZuschlagsgruppeSelect() {
  const { currentStandort } = useStandortContext();
  const { zuschlagsgruppen } = useZuschlagsgruppen(currentStandort.id);
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const { ctx } = useAnlageassistentContext();
  return (
    <form.AppField
      name="bezahlung.zuschlaege.zuschlagsgruppe"
      listeners={{
        onChange: () => {
          ctx.validateCurrentSubStep();
        },
      }}>
      {(field) => (
        <FieldBase
          label={t(
            'domain.mitarbeiter.create.steps.bezahlung.zuschlaege.form.zuschlagsgruppe.label',
          )}>
          <Select
            value={field.state.value ?? undefined}
            onValueChange={(val) => {
              field.handleChange(val);
            }}>
            <SelectTrigger>
              <SelectValue
                placeholder={t(
                  'domain.mitarbeiter.create.steps.bezahlung.zuschlaege.form.zuschlagsgruppe.placeholder',
                )}
              />
            </SelectTrigger>
            <SelectContent>
              <SelectClearItem onClick={() => field.handleChange(null)}>
                {t(
                  'domain.mitarbeiter.create.steps.bezahlung.zuschlaege.form.zuschlagsgruppe.resetItem',
                )}
              </SelectClearItem>
              {zuschlagsgruppen.map((zuschlagsgruppe) => (
                <SelectItem key={zuschlagsgruppe.id} value={zuschlagsgruppe.id}>
                  {zuschlagsgruppe.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </FieldBase>
      )}
    </form.AppField>
  );
}
